module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "toc-title"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/04_Illustrations"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("List of Illustrations")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Preface"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Preface")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter01"
    }
  }, [_c('span', {
    staticClass: "toccj"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 1:")])]), _vm._v(" Storms, Sickness and Near Shipwrecks")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter02"
    }
  }, [_c('span', {
    staticClass: "toccj"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 2:")])]), _vm._v(" First Impressions")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toccj"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 3:")])]), _vm._v(" Long Marches and Cold Nights")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toccj"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 4:")])]), _vm._v(" Sun and Sickness")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toccj"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 5:")])]), _vm._v(" Bad Food and Little of It")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toccj"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 6:")])]), _vm._v(" The Allied Nations")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toccj"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 7:")])]), _vm._v(" Thoughts on Portugal, Spain and France")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toccj"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 8:")])]), _vm._v(" Billets and Cantonments")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toccj"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 9:")])]), _vm._v(" Camp Life")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toccj"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 10:")])]), _vm._v(" Corresponding with Home")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toccj"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 11:")])]), _vm._v(" Discipline and Punishment")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toccj"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 12:")])]), _vm._v(" The Enemy")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toccj"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 13:")])]), _vm._v(" Girls, Women and Nuns")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toccj"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 14:")])]), _vm._v(" The Experience of Battle")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toccj"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 15:")])]), _vm._v(" Sieges")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toccj"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 16:")])]), _vm._v(" Wounds and Hospitals")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toccj"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 17:")])]), _vm._v(" The Ultimate Sacrifice")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Conclusion")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bibliography")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 66
// module chunks = 0